import { render, staticRenderFns } from "./FaqRegister.vue?vue&type=template&id=470515f5&"
import script from "./FaqRegister.vue?vue&type=script&lang=js&"
export * from "./FaqRegister.vue?vue&type=script&lang=js&"
import style0 from "./FaqRegister.vue?vue&type=style&index=0&id=470515f5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports